module.exports = __webpack_public_path__ + "media/images/menu/camelopardalis-3b8b13acab4953549315ba29fe2a5e58.jpg";